module.exports = __webpack_public_path__ + "static/media/slide-6.caf61425.jpg";